import { render, staticRenderFns } from "./size-select.vue?vue&type=template&id=3d5406b7&scoped=true&lang=pug"
import script from "./size-select.vue?vue&type=script&lang=js"
export * from "./size-select.vue?vue&type=script&lang=js"
import style0 from "./size-select.vue?vue&type=style&index=0&id=3d5406b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5406b7",
  null
  
)

export default component.exports